import CompanyQuoteQuote from './CompanyQuoteQuote'
// Uncomment the below to migrate to stateful component
// import CompanyQuoteQuoteContainer from './CompanyQuoteQuoteContainer'

export { CompanyQuoteQuote }
export default CompanyQuoteQuote
// Uncomment the below to migrate to stateful component
// export { CompanyQuoteQuoteContainer }
// export default { CompanyQuoteQuoteContainer }
